import { FormElementModel } from "../../../models/FormElementModel";
import { lengthValidator } from "../../../../utils/formsValidation";
import { t } from "i18next";
import { format } from "date-fns";

export const childRegisterForm = (register: any): FormElementModel[] => [
  {
    name: "name",
    type: "text",
    text: t("imie"),
    isLabel: true,
    register: { ...register("name", { ...lengthValidator(true, 2) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    register: { ...register("lastName", { ...lengthValidator(true, 2) }) },
  },
  {
    name: "birthDate",
    type: "date",
    text: t("data_urodzenia"),
    isLabel: true,
    max: format(new Date(), "yyyy-MM-dd"),
    register: {
      ...register("birthDate", {
        required: t("pole_wymagane"),
        validate: (value: string) => {
          if (!value) return t("pole_wymagane");
          const selectedDate = new Date(value);
          const today = new Date();
          if (selectedDate > today) {
            return t("data_nie_moze_byc_z_przyszlosci");
          }
          return true;
        },
      }),
    },
  },
];

